export class Product {

    id?: number;
    name?: string;
    quantity?: number;
    price?: number;
    purchasePrice?: number;
    description?: string;
    codeBare?: string | number;
    unit?: string;
    category?: string;
    subCategory?: string;
    productFamily?: string;
    imageUrl?: string;
    constructor(id?: number, name?: string, quantity?: number, price?: number, purchasePrice?: number, description?: string, codeBare?: string | number, unit?: string) {
        this.id = id;
        this.name = name;
        this.quantity = quantity;
        this.price = price;
        this.purchasePrice = purchasePrice;
        this.description = description;
        this.codeBare = codeBare;
        this.unit = unit;
        this.category = undefined;
        this.subCategory = undefined;
        this.productFamily = undefined;
        this.imageUrl = undefined;
    }

  }